import { Link, Navigate } from 'react-router-dom';

const Accueil = () => {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const role = user.role?.toLowerCase();

  // Vérification du token
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  const Menus = {
    admin: [
      { to: '/admin/evenements', label: 'Gestion des Événements', pathimg: '/assets/evenement.jpg', color: 'bg-blue-50 border-blue-100' },
      { to: '/vehicules', label: 'Gestion des Véhicules', pathimg: '/assets/vehicule.jpg', color: 'bg-green-50 border-green-100' },
      { to: '/admin/users', label: 'Gestion des Utilisateurs', pathimg: '/assets/utilisateur.jpg', color: 'bg-purple-50 border-purple-100' },
      { to: '/admin/conges', label: 'Gestion des Congés', pathimg: '/assets/conge.jpg', color: 'bg-amber-50 border-amber-100' },
      { to: '/admin/materiels', label: 'Gestion des Matériels', pathimg: '/assets/materiel.jpg', color: 'bg-indigo-50 border-indigo-100' },
    ],

    validateur: [
      { to: '/validateur/validation-evenements', label: 'Gestion des Événements', pathimg: '/assets/evenement.jpg', color: 'bg-blue-50 border-blue-100' },
      { to: '/validateur/materiels', label: 'Gestion des Matériels', pathimg: '/assets/materiel.jpg', color: 'bg-indigo-50 border-indigo-100' },
      { to: '/validateur/conges', label: 'Gestion des Congés', pathimg: '/assets/conge.jpg', color: 'bg-amber-50 border-amber-100' },
      { to: '/validateur/vehicules', label: 'Gestion des Véhicules', pathimg: '/assets/vehicule.jpg', color: 'bg-green-50 border-green-100' },
    ],

    magasinier: [
      { to: '/magasinier/livraisons', label: 'Gestion des Livraisons', pathimg: '/assets/evenement.jpg', color: 'bg-blue-50 border-blue-100' },
      { to: '/vehicules', label: 'Gestion des Véhicules', pathimg: '/assets/vehicule.jpg', color: 'bg-green-50 border-green-100' },
      { to: '/magasin', label: 'Gestion des Matériels', pathimg: '/assets/materiel.jpg', color: 'bg-indigo-50 border-indigo-100' },
      { to: '/magasinier/dashboard', label: 'Tableau de Bord', pathimg: '/assets/dashboard.jpg', color: ' border-gray-100' },
    ],

    client: [
      { to: '/client/mes-evenements', label: 'Gestion des Événements', pathimg: '/assets/evenement.jpg', color: 'bg-blue-50 border-blue-100' },
      { to: '/demandes-reparation/nouvelle', label: 'Gestion des Véhicules', pathimg: '/assets/vehicule.jpg', color: 'bg-green-50 border-green-100' },
      { to: '/demandes/nouvelle', label: 'Gestion des Matériels', pathimg: '/assets/materiel.jpg', color: 'bg-indigo-50 border-indigo-100' },
      { to: '/mes-conges', label: 'Gestion des Congés', pathimg: '/assets/conge.jpg', color: 'bg-amber-50 border-amber-100' },
    ],

    chef_equipe: [
      { to: '/vehicules', label: 'Gestion des Véhicules', pathimg: '/assets/vehicule.jpg', color: 'bg-green-50 border-green-100' },
      { to: '/mes-conges', label: 'Gestion des Congés', pathimg: '/assets/conge.jpg', color: 'bg-amber-50 border-amber-100' },
      { to: '/chef/materiels', label: 'Gestion des Matériels', pathimg: '/assets/materiel.jpg', color: 'bg-indigo-50 border-indigo-100' },
    ],

    mecanicien: [
      { to: '/vehicules', label: 'Gestion des Véhicules', pathimg: '/assets/vehicule.jpg', color: 'bg-green-50 border-green-100' },
      { to: '/mes-conges', label: 'Gestion des Congés', pathimg: '/assets/conge.jpg', color: 'bg-amber-50 border-amber-100' },
      { to: '/mes-demandes', label: 'Gestion des Matériels', pathimg: '/assets/materiel.jpg', color: 'bg-indigo-50 border-indigo-100' },
    ],
  };

  // Titres selon le rôle
  const roleTitles = {
    admin: 'Administration Système',
    validateur: 'Espace Validateur',
    magasinier: 'Espace Magasinier',
    client: 'Espace Client',
    chef_equipe: 'Espace Chef d\'Équipe',
    mecanicien: 'Espace Mécanicien',
  };

  return (
    <div className="min-h-screen p-4 md:p-8">
      <div className="max-w-7xl mx-auto">
        {/* En-tête */}
        <div className="mb-8">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-2">
            Bienvenue, {user.nom || 'Utilisateur'}
          </h1>
          <div className="flex items-center gap-3">
            <span className={`px-4 py-1 rounded-full text-sm font-medium ${
              role === 'admin' ? 'bg-red-100 text-red-800' :
              role === 'validateur' ? 'bg-blue-100 text-blue-800' :
              role === 'magasinier' ? 'bg-green-100 text-green-800' :
              role === 'client' ? 'bg-purple-100 text-purple-800' :
              role === 'chef_equipe' ? 'bg-amber-100 text-amber-800' :
              'bg-indigo-100 text-indigo-800'
            }`}>
              {roleTitles[role] || role}
            </span>
            <span className="text-gray-600 text-sm">
              {Menus[role]?.length || 0} modules disponibles
            </span>
          </div>
        </div>

        {/* Section des modules */}
        <div className="p-2">
          <h2 className="text-2xl font-bold text-gray-800 mb-6 pb-4 border-b border-gray-100">
            🚀 Modules disponibles
          </h2>
          
          {Menus[role] ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 text-center">
              {Menus[role].map((item, index) => (
                <Link
                  key={index}
                  to={item.to}
                  className="group relative"
                >
                  <div className="                
                    p-6 
                    h-full 
                    transition-all 
                    duration-300 
                    hover:shadow-xl 
                    hover:-translate-y-1 
                    flex flex-col items-center text-center
                  ">
                    {/* Icône/Image */}
                    <div className="mb-4">
                      <div className="w-40 h-40 rounded-full bg-white shadow-md group-hover:shadow-lg transition-shadow">
                        <img
                          src={item.pathimg}
                          alt={item.label}
                          className="w-40 h-40 rounded-full object-cover border shadow"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = '/assets/default-module.jpg';
                          }}
                        />
                      </div>
                    </div>

                    {/* Label */}
                    <h3 className="text-lg font-semibold text-gray-800 mb-2 group-hover:text-blue-600 transition-colors">
                      {item.label}
                    </h3>

                    {/* Badge d'accès */}
                    <div className="mt-2 flex items-center justify-center gap-2">
                      <span className="text-black text-sm font-medium">
                        Accéder
                      </span>
                      <svg 
                        className="w-4 h-4 text-black transform group-hover:translate-x-1 transition-transform" 
                        fill="none" 
                        stroke="currentColor" 
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </div>

                    {/* Effet de hover */}
                    <div className="absolute inset-0 border-2 border-transparent group-hover:border-blue-400 rounded-2xl transition-all duration-300 pointer-events-none opacity-0 group-hover:opacity-100" />
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <div className="text-center py-12">
              <div className="mx-auto w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-6">
                <svg className="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.282 16.5c-.77.833.192 2.5 1.732 2.5z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-700 mb-2">
                Aucun accès configuré
              </h3>
              <p className="text-gray-500">
                Le rôle <span className="font-medium">{role}</span> n'a pas de modules définis.
              </p>
              <p className="text-gray-500 text-sm mt-2">
                Veuillez contacter l'administrateur système.
              </p>
            </div>
          )}
        </div>

        {/* Pied de page */}
        <div className="mt-8 text-center text-gray-500 text-sm">
          <p>
            Sélectionnez un module pour accéder aux fonctionnalités correspondantes.
            <span className="block text-gray-400 mt-1">
              Dernière connexion : {new Date().toLocaleDateString('fr-FR')}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Accueil;